import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SecondaryNavigation from '../../../../../common/SecondaryNavigation';
import {
  getDropdownLabel,
  isDropdownLabelActive,
  isDropdownItemActive,
  getCustomReportLink,
} from '../../utils';
import { CUSTOM_REPORTS_PATH } from '../../constants';


const CustomReportsDropdown = ({
  className,
  items,
  fetched,
  error,
  pathname,
  mobile,
  WrapperComponent,
  canEditCustomReports,
  compact,
}) => (
  <WrapperComponent
    {...(mobile ? {} : {
      className: classnames(
        'c-secondary-navigation__item c-secondary-navigation__item--dropdown c-custom-report-menu__dropdown',
        className,
        { 'is-active': isDropdownLabelActive(items, pathname) },
      ),
      label: getDropdownLabel(items, pathname),
      labelClassName: 'c-custom-report-menu__dropdown-label',
      alignment: 'right',
      showIcon: true,
      key: `custom-reports-dropdown-${compact ? 'compact' : 'not-compact'}`,
    })}
  >
    <SecondaryNavigation.Item
      mobile
      display-if={mobile}
      label="Custom Reports"
    />
    <SecondaryNavigation.Item
      mobile={mobile}
      className={classnames(
        'u-co-gray-3',
        {
          'u-text-center': !mobile,
          'u-pl+': mobile,
        }
      )}
      label={!error ? 'Loading...' : 'Data is required to use this feature.'}
      display-if={!fetched}
    />
    <SecondaryNavigation.Item
      mobile={mobile}
      className={classnames(
        'u-co-gray-3',
        {
          'u-text-center': !mobile,
          'u-pl+': mobile,
        }
      )}
      label={<span>You don’t have any custom<br />reports yet.</span>}
      display-if={fetched && !items.length}
    />
    { items.map(item => (
      <button
        key={item.id}
        className="c-btn--transparent"
      >
        <SecondaryNavigation.Item
          label={item.name}
          to={getCustomReportLink(item)}
          mobile={mobile}
          className={classnames({ 'u-pl+': mobile })}
          active={isDropdownItemActive(items, item, pathname)}
        />
      </button>
    ))}
    <div className="c-custom-report-menu__divider u-mh" display-if={!mobile && canEditCustomReports} />
    <SecondaryNavigation.Item
      to={`${CUSTOM_REPORTS_PATH}/new`}
      label="+ New Custom Report"
      className={classnames(
        'c-btn--link',
        {
          'u-text-center': !mobile,
          'u-pl+': mobile,
        }
      )}
      mobile={mobile}
      display-if={canEditCustomReports}
    />
  </WrapperComponent>
);

CustomReportsDropdown.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
  fetched: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  pathname: PropTypes.string.isRequired,
  mobile: PropTypes.bool,
  WrapperComponent: PropTypes.elementType.isRequired,
  canEditCustomReports: PropTypes.bool.isRequired,
  compact: PropTypes.bool.isRequired,
};

CustomReportsDropdown.defaultProps = {
  className: '',
  mobile: false,
  items: [],
};

export default CustomReportsDropdown;
